export default __webpack_public_path__ + "static/base-lite-scheda-tecnica-768761393e22bcdeee5f8d86f36be8b9.pdf";